var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeclinedRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Declined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Declined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u653E\\u5927\\u5BF9\\u53F7",
    fill: "#ce2543"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-17",
    cx: 44.5,
    cy: 44.5,
    r: 44.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(44.500000, 44.500000) rotate(-225.000000) translate(-44.500000, -44.500000) ",
    x: 21.9942529,
    y: 39.8965517,
    width: 45.0114943,
    height: 9.20689655,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(44.500000, 44.500000) rotate(-315.000000) translate(-44.500000, -44.500000) ",
    x: 21.9942529,
    y: 39.8965517,
    width: 45.0114943,
    height: 9.20689655,
    rx: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclinedRed);
export default __webpack_public_path__ + "static/media/declined-red.1f071a40fd2f8795a158a00a1e9048d8.svg";
export { ForwardRef as ReactComponent };